import { useAppSelector } from '@/redux/hooks/useAppState'
import {
	manualExclusionFiltersSelector,
	manualInclusionFiltersSelector,
} from '@/redux/store/slices/grid/gridSlice'
import { useTheme } from '@mui/material'
import { Layer, Source } from 'react-map-gl/mapbox'

import { useManualFilterGeoJson } from './hooks/useManualFilterGeoJson'

import type { AggregatedDemographics } from 'honeygrid-types'
import type { FC } from 'react'

interface ManualFilterLayerProps {
	manualFilterKey: 'inclusion' | 'exclusion'
	cellLookupObject?: AggregatedDemographics['cells']
}

export const ManualFilterLayer: FC<ManualFilterLayerProps> = ({
	manualFilterKey,
	cellLookupObject,
}) => {
	const manualInclusionFilters = useAppSelector(manualInclusionFiltersSelector)
	const manualExclusionFilters = useAppSelector(manualExclusionFiltersSelector)

	const manualFilters =
		manualFilterKey === 'inclusion' ? manualInclusionFilters : manualExclusionFilters
	const manualFilterGeoJson = useManualFilterGeoJson(manualFilters, cellLookupObject)
	const theme = useTheme()
	let fillColor
	switch (manualFilterKey) {
		case 'inclusion':
			fillColor = theme.palette.primary.main
			break
		case 'exclusion':
			fillColor = theme.palette.error.light
			break
		default:
			fillColor = theme.palette.primary.main
			break
	}
	return (
		<>
			{manualFilterGeoJson ? (
				<Source id={manualFilterKey} type="geojson" data={manualFilterGeoJson}>
					<Layer
						id={`${manualFilterKey}-fill`}
						type="fill"
						paint={{
							'fill-color': fillColor,
							'fill-opacity': 0.7,
						}}
					/>
					<Layer
						id={`${manualFilterKey}-line`}
						type="line"
						paint={{
							'line-color': '#000',
							'line-width': 1,
							'line-opacity': 0.25,
						}}
					/>
				</Source>
			) : null}
		</>
	)
}
